<div class="background-hover" [formGroup]="bannerFormGroup">
    <div class="row">
        <div class="col-7">
            <div class="float-end">
                <div class="row gx-1">
                    <div class="col-auto">
                        <button class="btn btn-sm btn-primary" (click)="updateBanner()">
                            <i class="fas fa-save"></i> Save
                        </button>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-sm btn-outline-danger" (click)="displayDeleteBanner()" *ngIf="!deleteBannerVisible">
                            <i class="fas fa-trash-alt"></i> Delete
                        </button>
                        <button class="btn btn-sm btn-danger" (click)="deleteBanner()" *ngIf="deleteBannerVisible">
                            <i class="fas fa-exclamation-circle"></i> Confirm
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <code>#{{ banner.id }}</code>
            </div>
            <div class="mb-3">
                <label for="bannerNameInput_{{ banner.id }}">Name</label>
                <input type="text" class="form-control" id="bannerNameInput_{{ banner.id }}" formControlName="bannerNameInput" placeholder="Name...">
            </div>
            <div class="mb-3">
                <label for="bannerLinkInput_{{ banner.id }}">Link</label>
                <input type="text" class="form-control" id="bannerLinkInput_{{ banner.id }}" formControlName="bannerLinkInput" placeholder="https://www.mykronoz.com, https://www.facebook.com/mykronoz, ...">
            </div>
            <div class="mb-3">
                <label>Filters</label>
                <div>
                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" id="bannerActiveCheckbox_{{ banner.id }}" formControlName="bannerActiveCheckbox">
                        <label class="form-check-label" for="bannerActiveCheckbox_{{ banner.id }}">Default</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" id="bannerZeTimeCheckbox_{{ banner.id }}" formControlName="bannerZeTimeCheckbox">
                        <label class="form-check-label" for="bannerZeTimeCheckbox_{{ banner.id }}">ZeTime</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" id="bannerZeFit4Checkbox_{{ banner.id }}" formControlName="bannerZeFit4Checkbox">
                        <label class="form-check-label" for="bannerZeFit4Checkbox_{{ banner.id }}">ZeFit4</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" id="bannerZeRound2Checkbox_{{ banner.id }}" formControlName="bannerZeRound2Checkbox">
                        <label class="form-check-label" for="bannerZeRound2Checkbox_{{ banner.id }}">ZeRound2</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" id="bannerZeSport2Checkbox_{{ banner.id }}" formControlName="bannerZeSport2Checkbox">
                        <label class="form-check-label" for="bannerZeSport2Checkbox_{{ banner.id }}">ZeSport2</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-5">
            <a href="{{ banner.link }}">
                <span class="d-block text-truncate">
                    <i class="fas fa-external-link-alt"></i> {{ banner.link }}
                </span>
                <img class="img-fluid w-100" src="{{ banner.url }}">
            </a>
        </div>
    </div>
    <div *ngIf="banner.locales.length > 0">
        <div formArrayName="bannerLocaleFormArray" *ngFor="let localeFormGroup of getBannerLocaleFormArray().controls; let i = index;">
            <div [formGroupName]="i">
                <banner-locale [banner]="banner" [formGroup]="localeFormGroup" (refreshBanners)="emitRefreshEvent()"></banner-locale>
            </div>
        </div>
    </div>
    <div>
        <h5 (click)="newLocaleBannerVisible = !newLocaleBannerVisible" style="cursor: pointer;">
            Upload a new locale
            <span *ngIf="!newLocaleBannerVisible">
                <i class="fas fa-caret-right align-text-bottom"></i>
            </span>
            <span *ngIf="newLocaleBannerVisible">
                <i class="fas fa-caret-down align-text-bottom"></i>
            </span>
        </h5>
        <div [hidden]="!newLocaleBannerVisible" [formGroup]="newLocaleBannerFormGroup">
            <div class="mb-3 row">
                <div class="col">
                    <input type="file" accept="image/*" class="form-control" id="newLocaleBannerFileInput_{{ banner.id }}" (change)="newLocaleBannerFileInputChange($event)" formControlName="newLocaleBannerFileInput">
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-3">
                    <input type="text" class="form-control" placeholder="Locale (en, fr, ...)" formControlName="newLocaleBannerLocaleInput">
                </div>
                <div class="col-9">
                    <input type="text" class="form-control" placeholder="Link (https://www.mykronoz.com, https://www.facebook.com/mykronoz, ...)" formControlName="newLocaleBannerLinkInput">
                </div>
            </div>
            <div class="mb-3">
                <button class="btn btn-sm btn-primary" [disabled]="newLocaleBannerFormGroup.invalid" (click)="uploadNewBannerLocale()">
                    <i class="fas fa-cloud-upload-alt"></i> Upload
                </button>
            </div>
        </div>
    </div>
</div>